function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayLittleLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "200px",
    height: "200px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.987
    },
    fill: "#fefffe",
    d: "M 30.5,3.5 C 37.8409,3.33368 45.1742,3.50034 52.5,4C 98.4099,29.869 143.91,56.369 189,83.5C 197.933,99.3173 194.433,111.484 178.5,120C 136.5,144 94.5,168 52.5,192C 37.6469,197.61 26.8136,193.444 20,179.5C 19.3333,125.167 19.3333,70.8333 20,16.5C 22.2574,11.0846 25.7574,6.75127 30.5,3.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayLittleLogo);
export default __webpack_public_path__ + "static/media/Play-little_logo.3c11e96bdda70939d8fc33bc02d20c3f.svg";
export { ForwardRef as ReactComponent };